import React  from "react";
import Card from "components/card";
import BarChartBase from "components/charts/BarChartBase";

const data = [
    { month: "May", hours: 168 },
    { month: "Jun", hours: 176 },
    { month: "Jul", hours: 172 },
    { month: "Aug", hours: 180 },
    { month: "Sep", hours: 168 },
    { month: "Oct", hours: 152 },
];

const MyAttendance = () => {
    return (
        <Card className= "text-slate-900 flex flex-col gap-6 rounded-xl border border-slate-200 bg-white">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 [.border-b]:pb-6 pb-3">
                <h4 className="text-[16px]">
                    My Attendance
                </h4>
                <p className="text-slate-700 text-[11px]">
                    Monthly work hours over 6 months
                </p>
            </div>
            <div className="px-6 pb-6 pt-2"> 
                <BarChartBase 
                    data={data}
                    xKey="month"
                    yKey="hours"
                />
            </div>
        </Card>
    )
};
export default MyAttendance;